module.exports = __webpack_public_path__ + "static/img/recommend_failed.08ae3227.png";